export default __webpack_public_path__ + "static/accessibilita-inclusivita-sviluppo-software-custom-952cd6918afee9fd31e88ebd138daa93.jpg";